import * as CubeTree from '../cubeTree/index';

function isGoods(target: CubeId): boolean {
    return CubeTree.isGoods(target);
}

function isBafflePlate(target: CubeId): boolean {
    return CubeTree.isBafflePlate(target);
}

function isTextarea(target: CubeId): boolean {
    return CubeTree.isTextarea(target);
}

export {
    isGoods,
    isBafflePlate,
    isTextarea
};
